/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable linebreak-style */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/jsx-sort-props */
import React, { useRef, useState } from "react";
// import { getOperationsList } from 'src/services/operationsService';
import AMMaterialTable from "./AMMatrialTable";

import {
  Box,
  Alert,
  IconButton,
  Button,
  Grid,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Divider as MuiDivider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  Add as AddIcon,
  // Edit as EditIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  FilterList as FilterListIcon,
  // CloudUpload as CloudUploadIcon,
  // KeyboardVoice as KeyboardVoiceIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  //Save as SaveIcon,
} from "@mui/icons-material";
//import Filter from "src/components/common/Filter";
import { getCaption } from "src/utils/dictionary";
import useCurrentPath from "src/hooks/useCurrentPath";
import { useNavigate } from "react-router-dom";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  getSelectedCompany,
  getSelectedBranch,
} from "src/services/httpService";
import { spacing } from "@mui/system";
import { toast } from "react-toastify";
import styled from "@emotion/styled";
import AMFilter from "src/pages/components/AMFilter";

import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

const Divider = styled(MuiDivider)(spacing);
function IndexList(props) {
  const [filterKey, setFilterKey] = useState(0);
  const [openFilterDialog,setOpenFilterDialog]=useState(false);
  const [filterCriteria,setFilterCriteria]=useState({});
  const tableRef = useRef(null);
  const { routePath, pathname } = useCurrentPath();
  let navigate = useNavigate();

  const handleApplyFilter = (criteria) => {
    // props.onApplyFilter(criteria);
    setFilterCriteria(criteria);
    // console.log('tableRef.current.onQueryChange start');
     tableRef.current && tableRef.current.onQueryChange();
    // console.log('tableRef.current.onQueryChange start');
    setOpenFilterDialog(false);
  };

  const {
    columns,
    title,
    menuItemCode,
    getAll,
    filterControls,
    removeActions,
    extraOptions,
    extrActions,
  } = props;
  const extrActions2=extrActions||[]; 
  const selectedCompany = getSelectedCompany();
  const selectedBranch = getSelectedBranch();
  if (!selectedCompany || !selectedBranch) {
    return (
      <Box mb={3}>
        <Alert
          mb={4}
          severity="error"
          action={
            <IconButton aria-label="close" color="inherit" size="small">
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <ul style={{ paddingLeft: 10 }}>
            <li key={Math.random()}>
              {getCaption("please_select_company_and_branch")}
            </li>
          </ul>
        </Alert>
      </Box>
    );
  }
  return (
    <>
      <Grid container spacing={4}>
        {filterControls && filterControls.length > 0 && (
           <Dialog
                  open={openFilterDialog}
                  onClose={() => setOpenFilterDialog(false)}
                  aria-labelledby="draggable-dialog-title"
                     PaperComponent={PaperComponent}
             >
                  <DialogTitle id="draggable-dialog-title"
                  display="flex" 
            alignItems="center" 
                justifyContent="space-between" 
            width="100%"
            style={{ cursor: 'move' }} 
             >
                    {getCaption("filter_data")}
                     <Button
                      mr={2}
                      size="small"
                      onClick={() => setOpenFilterDialog(false)}
                      color="warning"
                    >
                      <CloseIcon />
                      {getCaption("cancel")}
                    </Button>
                  </DialogTitle>
                  <Divider my={0} />
                  <DialogContent>{
                <AMFilter
            key={JSON.stringify(filterCriteria)}
            controls={filterControls}
            initialCriteria={filterCriteria || {}}
            onApply={handleApplyFilter}
            applyTitle={getCaption("apply_filter")}
            expanded
            withoutAccordionSummary
          />
          }</DialogContent>
                  
                </Dialog>
                
                
        )}
      
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          {columns.length > 0 && (
            <AMMaterialTable
              title={title}
              tableRef={tableRef}
              columns={columns}
              actions={removeActions?[...extrActions2]:[
                {
                  icon: "edit",
                  // icon: (
                  //   <Tooltip title="Click here to View" placement="top">
                  //     <RemoveRedEyeIcon
                  //       onClick={(event) => {
                  //         if (props.data && props.data.id)
                  //           navigate(pathname + props.data.id);
                  //       }}
                  //     />
                  //   </Tooltip>
                  // ),
                  onClick: (event, rowData) => {
                    if (rowData && rowData.id) navigate(pathname + rowData.id);
                  },
                  //  tooltip: "Click here to View/Edit", //getCaption("view_edit"),
                },
                // {
                //   icon: "print",
                //   onClick: (event, rowData) => {
                //     console.log(rowData);
                //   },
                //   tooltip: "print", //getCaption("view_edit"),
                // },
                // {
                //   icon: "delete",
                //   onClick: (event, rowData) => {
                //     console.log(rowData);
                //   },
                //   tooltip: "delete", //getCaption("view_edit"),
                // },
                {
                  icon: () => (
                    <div style={{ margin: "auto" }}>
                      <Typography color="textPrimary">{getCaption("filter")}</Typography>{" "}
                      <FilterListIcon />
                    </div>
                  ),
                  isFreeAction: true,
                  onClick: (event, rowData) => {
                    setOpenFilterDialog(true);
                    console.log(rowData);
                  },
                  tooltip: getCaption("filter_data"),
                },
              ...extrActions2]}
              // components={{
              //   Action: (props) => {
              //     if (props.action.icon === "edit") {
              //       return (
              //         <Tooltip title="Click here to View" placement="top">
              //           <RemoveRedEyeIcon
              //             onClick={(event) => {
              //               if (props.data && props.data.id)
              //                 navigate(pathname + props.data.id);
              //             }}
              //           />
              //         </Tooltip>
              //         // </Button>
              //       );
              //     }
              //   },
              // }}
              options={{
                search: false,
                //actionsColumnIndex: -1, // Order of actions column Default=0    ## -1 = last columns
                columnsButton: true, // Flag for columns button that controls which column could be rendered
                grouping: true,
                emptyRowsWhenPaging: false,
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                //exportButton: true,
                //exportAllData: true,
                //exportFileName: 'data',
                // rowStyle: rowData => ({
                //   backgroundColor: (rowData.tableData.id % 2 == 0) ? '#FFF' : '#fafafa',
                // }),
                // headerStyle: {
                //   backgroundColor: '#f5f5f5',
                //   //   color: '#FFF'
                // },
                padding: "dense", // Padding of cells and rows
                margin: "dense", // Padding of cells and rows
                // toolbar: false,
                // showTitle: false,
...extraOptions

              }}
              data={(query) =>
                new Promise((resolve, reject) => {
                  const orderBy = query.orderBy ? query.orderBy.field : "";
                  // getOperationsList(formId, query.pageSize, query.page + 1, orderBy, query.orderDirection, criteria)
                  getAll(
                    menuItemCode,
                    query.pageSize,
                    query.page + 1,
                    orderBy,
                    query.orderDirection,
                    filterCriteria
                  ).then((result) => {
                    const { data } = result;
                    if (data) {
                      let d = [];
                      try {
                        d = JSON.parse(data.dataList);
                      } catch (error) {}
                      resolve({
                        data: d,
                        page: data.pageNumber - 1,
                        totalCount: data.totalCount,
                      });
                    } else {
                      reject();
                    }
                  });
                })
              }
            />
          )}
        </Grid> 
      </Grid>
    </>
  );
}

export default IndexList;
